import { useListPanelGroups } from './dashboard-provider-api';
import { PanelGroupItemId } from './panel-group-slice';

/**
 * Returns panel group id and layout id for the first panel group that includes the input panel key.
 * A given panel key JSON ref may be used in multiple panel groups, but in practice that should never happen.
 */
export function useFindPanelGroupItemId(panelKey?: string): PanelGroupItemId | undefined {
  const panelGroups = useListPanelGroups();
  if (panelKey === undefined) return undefined;
  for (const group of panelGroups) {
    if ('itemPanelKeys' in group) {
      for (const [key, value] of Object.entries(group.itemPanelKeys)) {
        if (value === panelKey) {
          return { panelGroupId: group.id, panelGroupItemLayoutId: key };
        }
      }
    }
  }
  return undefined;
}
